import React, { useState } from "react";
import { validatePresetName } from "../../../utils/graphPresets";

const axisLabel = (axis) => (axis === "RIGHT" ? "Right" : "Left");

const ManageGraphPresetsDialog = ({ open, presets, tags, busy, onClose, onRename, onDelete }) => {
    const [drafts, setDrafts] = useState({});
    const [pendingDelete, setPendingDelete] = useState(null);
    const [renameError, setRenameError] = useState("");

    if (!open) {
        return null;
    }

    const tagName = (tagId) => {
        const tag = (tags || []).find((item) => Number(item.id) === Number(tagId));
        return tag ? tag.name : `Tag ${tagId} unavailable`;
    };

    const rename = (preset) => {
        const name = drafts[preset.id] ?? preset.name;
        const error = validatePresetName(name, presets, preset.id);
        if (error) {
            setRenameError(error);
            return;
        }
        setRenameError("");
        onRename(preset.id, name.trim());
    };

    return (
        <div className="graph-page__dialog-backdrop" onMouseDown={onClose}>
            <div
                className="graph-page__dialog graph-page__dialog--wide"
                role="dialog"
                aria-modal="true"
                aria-labelledby="manage-presets-title"
                onMouseDown={(event) => event.stopPropagation()}
            >
                <h3 id="manage-presets-title">Manage Presets</h3>
                <p>Rename or delete a saved preset. Change tags, colors, and axes on the graph, then use Update Preset.</p>
                {renameError && <p className="graph-page__banner is-error" role="alert">{renameError}</p>}
                {presets.length === 0 && <p className="graph-page__empty">You have no saved presets yet.</p>}
                <ul className="graph-page__preset-list">
                    {presets.map((preset) => {
                        const savedTags = Array.isArray(preset.configuration?.tags) ? preset.configuration.tags : [];
                        return (
                            <li key={preset.id} className="graph-page__preset-item">
                                <div className="graph-page__preset-rename">
                                    <input
                                        aria-label={`Rename ${preset.name}`}
                                        value={drafts[preset.id] ?? preset.name}
                                        maxLength={80}
                                        onChange={(event) => setDrafts((current) => ({
                                            ...current,
                                            [preset.id]: event.target.value,
                                        }))}
                                    />
                                    <button type="button" className="graph-page__button" disabled={busy} onClick={() => rename(preset)}>
                                        Rename
                                    </button>
                                    {pendingDelete === preset.id ? (
                                        <>
                                            <button
                                                type="button"
                                                className="graph-page__button graph-page__button--danger"
                                                disabled={busy}
                                                onClick={() => onDelete(preset.id)}
                                            >
                                                Confirm delete
                                            </button>
                                            <button type="button" className="graph-page__button" onClick={() => setPendingDelete(null)}>
                                                Cancel
                                            </button>
                                        </>
                                    ) : (
                                        <button type="button" className="graph-page__button graph-page__button--danger" onClick={() => setPendingDelete(preset.id)}>
                                            Delete
                                        </button>
                                    )}
                                </div>
                                {pendingDelete === preset.id && (
                                    <p className="graph-page__banner is-warn" role="status">
                                        Delete {preset.name}? This removes the preset only. Tags and history stay in place.
                                    </p>
                                )}
                                <ol className="graph-page__preset-tags">
                                    {savedTags.map((item) => (
                                        <li key={`${preset.id}-${item.order}-${item.tag_id}`}>
                                            {item.order + 1}. {tagName(item.tag_id)}
                                            {" · "}{item.color_custom ? item.color : "Theme color"}
                                            {" · "}{axisLabel(item.axis)}
                                            {" · "}{item.visible === false ? "Hidden" : "Visible"}
                                        </li>
                                    ))}
                                </ol>
                            </li>
                        );
                    })}
                </ul>
                <div className="graph-page__actions">
                    <button type="button" className="graph-page__button" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default ManageGraphPresetsDialog;
